export default __webpack_public_path__ + "9d5feac97ace9b47c4ff9b8c74923da8.webp";